import React from "react";
import * as Sentry from "@sentry/react";
import Terms from "../screens/Info/Terms";
import Layout from "../layouts/index";

const TermsPage = () => {
  return (
    <Layout>
      <Terms />
    </Layout>
  );
};

export default TermsPage;
